<template>
    <div class="login-wrap">
        <remote-js src="https://pv.sohu.com/cityjson?ie=utf-8"></remote-js>
        <div class="ms-login">
            <div class="ms-title">友朋旅游同业-后台管理</div>
            <el-form :model="param" :rules="rules" class="ms-content" label-width="0px" ref="login">
                <el-form-item prop="username">
                    <el-input placeholder="管理员账号" v-model="param.username">
                        <el-button icon="el-icon-lx-people" slot="prepend"></el-button>
                    </el-input>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input
                            @keyup.enter.native="submitLogin()"
                            placeholder="管理员密码"
                            type="password"
                            v-model="param.password"
                    >
                        <el-button icon="el-icon-lx-lock" slot="prepend"></el-button>
                    </el-input>
                </el-form-item>
                <div class="login-btn">
                    <el-button @click="submitLogin()" type="primary">登录</el-button>
                </div>
                <p class="login-tips">Tips : 请使用分配的用户名/邮箱+密码登录。</p>
            </el-form>
        </div>
    </div>
</template>


<script>
    export default {
        data: function() {
            return {
                param: {
                    username: '',
                    password: '',
                    ip: '',
                    add: ''
                },
                rules: {
                    username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
                    password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
                }
            };
        },
        components: {
            'remote-js': {
                render(createElement) {
                    return createElement('script', { attrs: { type: 'text/javascript', src: this.src } });
                },
                props: {
                    src: { type: String, required: true }
                }
            }
        },
        methods: {
            //提交用户登录数据
            submitLogin() {
                this.$refs.login.validate(valid => {
                    if (valid) {
                        this.loginUser();
                    } else {
                        this.$message.error('请输入账号和密码');
                        return false;
                    }
                });
            },
            //用户登录处理
            async loginUser() {
                this.param.ip = returnCitySN['cip'];
                this.param.add = returnCitySN['cname'];
                const { data: res } = await this.$http.post('admin/member/login', {
                    query: this.param
                });
                if (res.code != 200) {
                    this.$message.error(res.msg + '，请重新登录!');
                } else {
                    this.$message.success(res.msg + '，欢迎你,' + res.user + '！');
                    sessionStorage.setItem('ml_userid', res.userid);
                    sessionStorage.setItem('ml_username', res.username);
                    sessionStorage.setItem('ml_role', res.role);
                    sessionStorage.setItem('ml_cityId', res.cityId);
                    this.$router.push('/');
                }
            }
        }
    };
</script>


<style scoped>
    .login-wrap {
        position: relative;
        width: 100%;
        height: 100%;
        background-image: url(../../assets/img/bg-4.jpg);
        background-size: 100%;
    }

    .ms-title {
        width: 100%;
        line-height: 50px;
        text-align: center;
        font-size: 20px;
        color: #2d8cf0;
        border-bottom: 1px solid #ddd;
    }

    .ms-login {
        position: absolute;
        left: 50%;
        top: 50%;
        width: 350px;
        margin: -190px 0 0 -175px;
        border-radius: 5px;
        background: rgba(255, 255, 255, 0.3);
        overflow: hidden;
    }

    .ms-content {
        padding: 30px 30px;
    }

    .login-btn {
        text-align: center;
    }

    .login-btn button {
        width: 100%;
        height: 36px;
        margin-bottom: 10px;
    }

    .login-tips {
        font-size: 12px;
        line-height: 30px;
        color: #fff;
    }
</style>
